<template>
  <div class="offer-item">
    <div class="desktop-offer-item" @click.stop="openTransactions(item.public_id)">
      <div class="name" :title="userName">{{ userName }}</div>
      <div class="issued">
        {{ offerIssuedDate }}
      </div>
      <div class="amount">
        {{ item.got_money / 100 }}
      </div>
      <div class="term">
        {{ offerTerm }}
      </div>
      <div class="percent">
        {{ offerPercent }}
      </div>
      <div class="income">
        {{ item.must_return_money / 100 }}
      </div>
      <div class="issued-by">
        {{ offerIssueDate }}
      </div>
      <div class="peni">{{ item.total_penalty / 100 }}</div>
      <div class="total-amount">
        {{ item.rest_debt / 100 }}
      </div>
      <div class="status">
        <div :class="item.status">
          {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
        </div>
      </div>
      <div class="pay" v-click-outside="hideLoanMenu">
        <!-- <img
          class="offer-menu-img"
          src="../../../public/custom/images/offer-menu.svg"
          alt="Offer menu image"
        /> -->
        <div class="offer-menu" @click.stop="openExpiredModal()" v-if="isLoanMenuOpen">
          <div class="expired-link">{{ $t('message.profile.lender.expiredLoan.link') }}</div>
          <div class="expired-text">{{ $t('message.profile.lender.expiredLoan.text') }}</div>
        </div>
      </div>
    </div>
    
    <div class="mobile-offer-item">
      <div class="top-line"></div>
      <div class="preview-block" :class="{'full-desc': isFullDesc}" @click.stop="descToggle()">
        <div class="mobile-name">{{ userName }}</div>
        <div class="mobile-amount">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
          <div class="data">{{ item.got_money / 100 }}</div>
        </div>
        <div class="mobile-percent">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
          <div class="data">{{ offerPercent }}</div>
        </div>
        <div class="mobile-income">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
          <div class="data">{{ item.must_return_money / 100 }}</div>
        </div>
        <div class="mobile-status">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
          <div :class="item.status">
            {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
          </div>
        </div>
        <div class="mobile-issued">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
          <div class="data">{{ offerIssuedDate }}</div>
        </div>
        <div class="mobile-term">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
          <div class="data">{{ offerTerm }}</div>
        </div>
        <div class="mobile-issued-by">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
          <div class="data">{{ offerIssueDate }}</div>
        </div>
        <div class="mobile-peni">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
          <div class="data">{{ item.total_penalty / 100 }}</div>
        </div>
        <div class="mobile-total-amount">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
          <div class="data">{{ (item.rest_debt) / 100 }}</div>
        </div>
        <div class="btn-block">
          <base-button
            :text="$t(`message.profile.borrower.activeOffers.transactions`)"
            class="transactions-btn"
            @click="openTransactions(item.public_id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: "lenderLoanItem",
  props: {
    item: Object,
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isLoanMenuOpen: false,
      isFullDesc: false
    }
  },
  methods: {
    descToggle() {
      this.isFullDesc = !this.isFullDesc;
    },
    openTransactions(id) {
      this.$router.push({name: 'loan', params: { id }});
    },
    openExpiredModal() {
      this.isLoanMenuOpen = false;
      this.$emit('openExpiredModal');
    },
    loanMenuToggle() {
      this.isLoanMenuOpen = !this.isLoanMenuOpen;
    },
    hideLoanMenu() {
      this.isLoanMenuOpen = false;
    }
  },
  computed: {
    userName() {
      const lastName =
        this.item?.Borrower?.name_ru?.family_name_ru;
      const name =
        (this.item?.Borrower?.name_ru?.given_name_ru).slice(
          0,
          1
        ) + ".";

      return `${lastName} ${name}`;
    },
    offerIssuedDate() {
      return new Date(this.item?.createdAt).toLocaleDateString();
    },
    offerTerm() {
      return this.item?.Offer?.loan_term_days + "д.";
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    offerIssueDate() {
      return new Date(this.item?.due_date).toLocaleDateString();
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-item {
  width: 100%;
}

.desktop-offer-item {
  width: 100%;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: calc(8px + 10 * (100vw / 1920));
  line-height: 135%;
  color: #121212;
  cursor: pointer;

  &:hover {
    background-color: #F6F8FF;
  }
}

.name {
  width: 125px;
  margin-right: 2px;
  @include overflow-elipsis;
}

.issued {
  width: 106px;
  margin-right: 2px;
}

.amount {
  width: 65px;
  margin-right: 2px;
}

.term {
  width: 45px;
  margin-right: 2px;
}

.percent {
  width: 87px;
  margin-right: 2px;
}

.income {
  width: 144px;
  margin-right: 2px;
}

.issued-by {
  width: 117px;
  margin-right: 2px;
}

.peni {
  width: 45px;
  margin-right: 2px;
}

.total-amount {
  width: 65px;
  margin-right: 2px;
}

.status {
  width: 117px;
  margin-right: 2px;
  font-size: calc(6px + 8 * (100vw / 1920));

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.pay {
  width: 23px;
  position: relative;
}

.offer-menu-img {
  height: 22px;
  width: 22px;
  cursor: pointer;
}

.offer-menu {
  width: 181px;
  padding: 10px 15px;
  box-sizing: border-box;
  position: absolute;
  bottom: -125px;
  right: -10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-size: 16px;
  line-height: 135%;
  color: #333333;
  white-space: nowrap;
  cursor: pointer;
  z-index: 3;
}

.expired-link {
  margin-bottom: 15px;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: #41BF7B;
}

.expired-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: rgba(51, 51, 51, 0.6);
  white-space: pre-line;
}

.btn-block {
  width: calc(70px + 49 * (100vw / 1920));
  height: 32px;
}

.payment,
.on_due,
.current_debt,
.payment_pending {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
}

.closed,
.paid,
.repaid {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #21a15c;
  background: #d6f9d3;
  border-radius: 6px;
}

.expired,
.overdue {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #c93434;
  background: #ffdbdb;
  border-radius: 6px;
}

.pay-btn ::v-deep {
  background-color: white;
  border: 2px solid #41bf7b;
  border-radius: 6px;
  color: #41bf7b;
  padding: 0;
  font-size: calc(8px + 8 * (100vw / 1920));
  font-weight: 600;

  &:hover {
    background-color: #41bf7b;
    color: white;
  }
}

.mobile-offer-item {
  width: 100%;
  padding-bottom: 10px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
}

.top-line {
  margin-bottom: 10px;
  width: 100%;
  height: 1px;
  background: #ECEEF0;
  border-radius: 3px;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 160px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.full-desc {
  height: auto;
}

.mobile-name {
  width: 100%;
  margin-bottom: 10px;
}

.mobile-amount,
.mobile-term,
.mobile-percent,
.mobile-income,
.mobile-status,
.mobile-issued,
.mobile-issued-by,
.mobile-peni,
.mobile-total-amount {
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.mobile-status div:last-of-type {
  font-size: 14px;
}

.title {
  font-size: 14px;
  line-height: 19px;
  color: #878787;
}

.btn-block {
  margin-top: 20px;
  width: 100%;
  height: 38px;
}

.transactions-btn ::v-deep {
  border-radius: 6px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

@media screen and (max-width: 850px) {
  .desktop-offer-item {
    display: none;
  }

  .mobile-offer-item {
    display: flex;
  }
}
</style>
